<opac-button class="back-button" type="text" (click)="goBack()">
  <opac-icon slot="start" icon="navigate_back"></opac-icon>
  {{ 'general.back' | translate }}
</opac-button>

<ng-container *ngIf="emptyFavorites$ | async">
  <opac-no-results [label]="'lists.noFavorites' | translate"> </opac-no-results>
</ng-container>

<ng-container *ngIf="(emptyFavorites$ | async) === false">
  <div class="header">
    <h1>{{ 'user.favorites.title' | translate }}</h1>
    <opac-button class="more-actions" [opac-menu-trigger]="listActionsMenu"
                 [ariaLabel]="'lists.moreActions' | translate" [opacTooltip]="'lists.moreActions' | translate">
      <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <opac-menu #listActionsMenu>
    <opac-menu-item (selected)="addTitles()">
      <opac-icon icon="add"></opac-icon>
      {{ 'lists.addTitles' | translate }}
    </opac-menu-item>

    <opac-menu-item (selected)="showDeleteAllFavoritesDialog.set(true)">
      <opac-icon icon="delete"></opac-icon>
      {{ 'general.removeAll' | translate }}
    </opac-menu-item>
  </opac-menu>

  <span class="header-subtitle">
    <span>{{ favoriteFacade.paginatedFavorites.itemsTotal }} {{ (favoriteFacade.paginatedFavorites.itemsTotal === 1 ? "general.item" : "general.items") | translate }}</span>
  </span>

  <opac-divider></opac-divider>

  <app-record-card-grid *ngIf="favoriteFacade.paginatedFavorites.items.length">
    <ng-container *ngFor="let favorite of favoriteFacade.paginatedFavorites.items">
      <app-user-favorite-item *ngIf="favorite.available" [favorite]="favorite"></app-user-favorite-item
    ></ng-container>
  </app-record-card-grid>

  <opac-infinite-scroll
    [disabled]="(isLoading$ | async) || favoriteFacade.paginatedFavorites.page === favoriteFacade.paginatedFavorites.numPages -1"
    [threshold]="100"
    (load)="loadMore()"></opac-infinite-scroll>

  <div class="public-list__more" *ngIf="loadingMoreItems">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
</ng-container>

<opac-confirmation-dialog
  [acceptLabel]="'general.accept'"
  [open]="showDeleteAllFavoritesDialog()"
  [title]="'general.removeAll' | translate"
  (accept)="removeAllFavorites()"
  (cancel)="showDeleteAllFavoritesDialog.set(false)">
  <p>{{'messages.favorites.confirmRemoveAll' | translate}}</p>
</opac-confirmation-dialog>